import { createAction, props } from '@ngrx/store';
import { RestApiError, SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { DashboardTile, FullscreenDashboardTile } from '../models/dashboard-tile.model';
import { Dashboard } from '../models/dashboard.model';
import { SaveDashboardTileLayoutConfigurations_saveDashboardTileLayoutConfigurations } from '../queries/generated/SaveDashboardTileLayoutConfigurations';
import { DashboardGridLayoutItem, DashboardGridLayoutItemConfigurationInput } from '../views/dashboard-view.component';

export const pageEntered = createAction('[Dashboard] Page entered');

export const pageLoadedSuccess = createAction(
   '[Dashboard] Page loaded success',
   props<{ dashboards: Dashboard[]; selectedDashboard: Dashboard | null }>()
);

export const pageLoadedFailure = createAction('[Dashboard] Page loaded failure', props<SingleGraphError>());

export const closeFullscreenTile = createAction('[Dashboard] Close fullscreen tile');

export const openFullscreenTile = createAction(
   '[Dashboard] Open fullscreen tile',
   props<{ config: FullscreenDashboardTile | null }>()
);

export const saveGridLayoutChange = createAction(
   '[Dashboard] Save grid layout change',
   props<{
      dashboardTileLayoutConfigurationInput: DashboardGridLayoutItemConfigurationInput[];
      columnLayoutSize: number;
   }>()
);

export const saveGridLayoutChangeSuccess = createAction(
   '[Dashboard] Save grid layout change success',
   props<{
      dirtyDashboardTileLayoutConfigurations: SaveDashboardTileLayoutConfigurations_saveDashboardTileLayoutConfigurations[];
      columnLayoutSize: number;
   }>()
);

export const saveGridLayoutChangeFailure = createAction(
   '[Dashboard] Save grid layout change failure',
   props<{ error: SingleGraphError }>()
);

export const optionsLoaded = createAction('[Dashboard] Options Loaded');

export const addDashboard = createAction('[Dashboard] Add dashboard', props<{ name: string }>());

export const addDashboardSuccess = createAction('[Dashboard] Add dashboard success', props<{ dashboard: Dashboard }>());

export const addDashboardFailure = createAction('[Dashboard] Add dashboard failure', props<SingleGraphError>());

export const deleteDashboard = createAction('[Dashboard] Delete dashboard');

export const renameDashboard = createAction('[Dashboard] Rename dashboard', props<{ name: string }>());

export const deleteDashboardSuccess = createAction(
   '[Dashboard] Delete dashboard success',
   props<{ dashboardId: number }>()
);

export const deleteDashboardFailure = createAction('[Dashboard] Delete dashboard failure', props<SingleGraphError>());

export const reloadSelectedDashboard = createAction('[Dashboard] Reload selected dashboard');

export const renameDashboardSuccess = createAction(
   '[Dashboard] Rename dashboard success',
   props<{ dashboard: Dashboard }>()
);

export const renameDashboardFailure = createAction('[Dashboard] Rename dashboard failure', props<SingleGraphError>());

export const reloadSelectedDashboardSuccess = createAction(
   '[Dashboard] Reload selected dashboard success',
   props<{ dashboard: Dashboard }>()
);

export const reloadSelectedDashboardFailure = createAction(
   '[Dashboard] Reload selected dashboard failure',
   props<SingleGraphError>()
);

export const updateDashboardTileOnSelectedDashboardById = createAction(
   '[Dashboard] Update dashboard tile',
   props<{ dashboardTileId: number }>()
);

export const updateDashboardTileOnSelectedDashboardByIdSuccess = createAction(
   '[Dashboard] Update dashboard tile success',
   props<{ dashboardTile: DashboardTile }>()
);

export const updateDashboardTileOnSelectedDashboardByIdFailure = createAction(
   '[Dashboard] Update dashboard tile failure',
   props<RestApiError>()
);

export const setCurrentDashboardColumnLayoutSize = createAction(
   '[Dashboard] Set current dashboard column layout size',
   props<{ currentDashboardColumnLayoutSize: number }>()
);

export const reloadDashboardForNewLayout = createAction(
   '[Dashboard] Reload dashboard layout',
   props<{ layout: DashboardGridLayoutItem[] }>()
);

export const reloadDashboardAfterResize = createAction(
   '[Dashboard] Reload dashboard layout after resize event',
   props<{ layout: DashboardGridLayoutItem[] }>()
);
